import React from "react";
import { injectIntl } from "react-intl";
import { Select, Button } from "antd";
import "./RightsManager.css";
import {
  RIGHTS_STATE_UNASSIGNED,
  RIGHTS_STATE_NOT_REQUIRED,
  RIGHTS_STATE_VALID,
  RIGHTS_STATE_EXPIRING,
  RIGHTS_STATE_EXPIRED,
  FILTER_TYPES
} from "../../constants/rights-constants";

const { Option } = Select;

const TYPE_LABEL_IDS = {
  image: "rights_manager_type_image",
  video: "rights_manager_type_video",
  audio: "rights_manager_type_audio",
  document: "rights_manager_type_document",
  font: "rights_manager_type_font"
};

/**
 * Barra de filtros del Gestor.
 *
 * El campo de tipo era antes un rótulo con candado ("Sólo piezas de contenido")
 * que ocupaba el lugar más visible sin hacer nada: el recorte lo aplicaba el
 * backend y no había forma de estrecharlo. Ahora es un filtro real. No incluye
 * tipografías, comprimidos ni ofimática a propósito: esos quedan fuera del
 * módulo por definición y el backend nunca los devuelve, así que ofrecerlos
 * daría siempre cero resultados.
 */
const RightsManagerFilters = ({
  rightsState,
  rightsStateDraft,
  onChangeState,
  types,
  typesDraft,
  onChangeTypes,
  onApplyTypes,
  onClearFilters,
  onExport,
  exporting,
  intl
}) => {
  // Habilita "Limpiar filtros" sólo cuando hay algo que limpiar: un botón que
  // siempre se puede apretar sin que pase nada es ruido.
  const hayFiltros =
    Boolean(rightsState) ||
    Boolean(rightsStateDraft) ||
    (types && types.length > 0) ||
    (typesDraft && typesDraft.length > 0);

  // Punto 12 de Ricardo: el tipo es multi-selección y antes refrescaba el panel
  // en cada tag, así que elegir "imagen y video" disparaba dos consultas y
  // mostraba un resultado intermedio. Ahora se elige y se aplica con "Ir".
  const sinAplicar =
    (typesDraft || []).join(",") !== (types || []).join(",") ||
    (rightsStateDraft || "") !== (rightsState || "");

  return (
  <div className="rm-filters">
    <div className="rm-select-wrap">
      <span>{intl.formatMessage({ id: "rights_manager_filter_type" })}:</span>
      <Select
        className="rm-select rm-type-select"
        mode="multiple"
        value={typesDraft}
        onChange={onChangeTypes}
        placeholder={intl.formatMessage({ id: "rights_manager_type_placeholder" })}
        maxTagCount={2}
        allowClear
      >
        {FILTER_TYPES.map(type => (
          <Option key={type} value={type}>
            {intl.formatMessage({ id: TYPE_LABEL_IDS[type] })}
          </Option>
        ))}
      </Select>
    </div>

    <div className="rm-select-wrap">
      <span>{intl.formatMessage({ id: "rights_manager_col_state" })}:</span>
      <Select
        className="rm-select rm-state-select"
        value={rightsStateDraft}
        onChange={onChangeState}
        placeholder={intl.formatMessage({ id: "rights_manager_state_placeholder" })}
        allowClear
      >
        <Option value={RIGHTS_STATE_UNASSIGNED}>
          {intl.formatMessage({ id: "rights_state_unassigned" })}
        </Option>
        <Option value={RIGHTS_STATE_NOT_REQUIRED}>
          {intl.formatMessage({ id: "rights_state_not_required" })}
        </Option>
        <Option value={RIGHTS_STATE_EXPIRED}>
          {intl.formatMessage({ id: "rights_state_expired" })}
        </Option>
        <Option value={RIGHTS_STATE_EXPIRING}>
          {intl.formatMessage({ id: "rights_state_expiring" })}
        </Option>
        <Option value={RIGHTS_STATE_VALID}>
          {intl.formatMessage({ id: "rights_state_valid" })}
        </Option>
      </Select>
    </div>

    {/* "Ir" va después de los dos selectores: así se arman tipo y estado y se
        aplican de una sola vez. Por eso el de estado también edita un borrador
        —si se aplicara solo, el botón quedaría a medias. Las tarjetas KPI
        siguen filtrando al instante: ahí el clic ES la acción. */}
    <Button
      className="rm-apply-types"
      type={sinAplicar ? "primary" : "default"}
      disabled={!sinAplicar}
      onClick={onApplyTypes}
    >
      {intl.formatMessage({ id: "rights_manager_apply_types" })}
    </Button>

    <Button
      className="rm-clear-filters"
      type="link"
      disabled={!hayFiltros}
      onClick={onClearFilters}
    >
      {intl.formatMessage({ id: "rights_manager_clear_filters" })}
    </Button>

    <div className="rm-grow" />
    <Button onClick={onExport} loading={exporting}>
      {intl.formatMessage({ id: "rights_manager_export_csv" })}
    </Button>
  </div>
  );
};

export default injectIntl(RightsManagerFilters);
